import jsrsasign from 'jsrsasign';

export function distinguishTitle() {
  if (location.href.indexOf('sentry.wzparking') > -1) {
    return '鹿城'
  } else if (location.href.indexOf('lgsentry') > -1 || location.href.indexOf('sentry.workingpark.cn') > -1) {
    return '龙港'
  } else if (location.href.indexOf('srsentry') > -1) {
    return '上饶'
  } else if (location.href.indexOf('tsentry') > -1) {
    return '停简单'
  } else if (location.href.indexOf('sfsentry.wzzhtc.cn') > -1) {
    return '数发'
  } else if (location.href.indexOf('whserver') > -1) {
    return '武汉'
  } else if (location.href.indexOf('sentry.pxyunshu.com') > -1) {
    return '萍乡'
  } else if (location.href.indexOf('server.api.zoeeasy') > -1 || process.env.NODE_ENV === 'build_testZy') {
    return '逐一'
  } else if (location.href.indexOf('cdparking') > -1 && location.href.indexOf('lgserver') === -1 && location.href.indexOf('tserver') === -1) {
    return '车都'
  } else if (location.href.indexOf('sentry.jianouzhibo.com') > -1) {
    return '建鸥'
  } else if (location.href.indexOf('sentry.weitingtech') > -1) {
    return '温州'
  } else {
    return '岗亭'
  }
}

/**
 * 转换金额,元,万元
 * **/
export function unitConvert(num) {
  var moneyUnits = ["元", "万元", "亿元", "万亿"];
  var dividend = 10000;
  var curentNum = num || 0;
  //转换数字
  var curentUnit = moneyUnits[0];
  //转换单位
  for (var i = 0; i <4; i++) {
    curentUnit = moneyUnits[i];
    if(strNumSize(curentNum)<5){
      break;
    }
    curentNum = curentNum / dividend
  }
  return [num < dividend ? curentNum : curentNum.toFixed(2), curentUnit];
}

function strNumSize(tempNum){
  var stringNum = tempNum ? tempNum.toString() : '0';
  var index = stringNum.indexOf(".");
  var newNum = stringNum;
  if(index != -1){
    newNum = stringNum.substring(0,index)
  }
  return newNum.length
}

export function getUrlParam(url) {
  url = url.split('#')[0]
  url = decodeURI(url) // 获取url中"?"符后的字串
  const res = {}
  if (url.indexOf('?') !== -1) {
    url = url.split('?')[1]
    const str = url.split('&')
    let param = []
    for (var i = 0; i < str.length; i++) {
      param = str[i].split('=')
      if (param.length === 1) {
        res.other = param[0]
      } else {
        res[param[0]] = unescape(param[1])
      }
    }
  }
  return res
}

export function handleAssign(url) {
  let basic;
  if (window.location.href.indexOf('#') > -1) {
    basic = window.location.href.split('/#')[0]
  } else {
    basic = window.location.href
  }
  if (basic.indexOf('/?') > -1) {
    if ((basic.indexOf('/?') + 1) === basic.indexOf('?')) {
      basic = basic.split('/?')[0]
    } else {
      basic = basic.split('?')[0]
    }
  }
  if (url === '/?redirect=2') {
    location.assign(`${basic}${url}`)
  } else {
    location.assign(`${basic}/#${url}`)
  }
}

export function newData(date, type) {
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  if (month < 10) { month = '0' + month }
  var day = date.getDate()
  if (day < 10) { day = '0' + day }
  var hh = date.getHours()
  if (hh < 10) { hh = '0' + hh }
  var mm = date.getMinutes()
  if (mm < 10) { mm = '0' + mm }
  var ss = date.getSeconds()
  if (ss < 10) { ss = '0' + ss }
  if (type === 'day') {
    return year + '-' + month + '-' + day
  } else if (type === 'time') {
    return hh + ':' + mm + ':' + ss
  } else {
    return year + '-' + month + '-' + day + ' ' + hh + ':' + mm + ':' + ss
  }
}

export function signature (signData) {
  // 私钥加签
  let signPrivateKey ="-----BEGIN RSA PRIVATE KEY-----\n"+
    "MIIEpAIBAAKCAQEA1zQkLfE91zlci2wSRM8gQN9u82BXk4ZUCrIny/dCpkkesROi\n"+
    "Eh4evl7olq+t1QRqX3TtJdhuzMl9WxCOvaAZD4YgQ+jZHMDvNohWQBaByAqzCL6x\n"+
    "t661o51XddauIVDEXk4h5b1nNKHB6vRyw/Hzim6NAKwgEx2DJUCOeQ4m9f72y1zu\n"+
    "L6aQBzJk94DCYhtrkQjkcXqD+aYWngEyZNEldY/Towj2OUfgO0avykMk0xQNlyM0\n"+
    "DF5LXP08xt04ukNXEWdftzvIfUhKBPyhlH7AQ1/gPvA7bGDouyy5gBhFQP52ye7r\n"+
    "/u7YChl3XpgKD6LOjJQlcwjMn1UN9CvRfqxQgwIDAQABAoIBAG3ZesJMyyFKcXfl\n"+
    "oWmoRLF4m9z1h56RSeLvz6qou0fAOT9wYyFWaKEKNzV71YLPrzCsscTItr4n96n9\n"+
    "SK94wnIPJ/ciK3km7rRqYYRzOKoQ9BR5qqO1NZif3x4SiG4PGT1+KoVn6f+Otjql\n"+
    "rtNgdM1r4uO9+N1pCiGA03jthWu5Wwb2Y4rP3wa9rSHTxeRbBQiku10p13aJ5nFg\n"+
    "XQLJtJiMyAa8BrgtMmYJ5eOtWGJwDZ+VXqCn/ZbpzEzhKGKk1kp6OgI6cuury8hf\n"+
    "G+aKpCmD3s/JtvEHmn1LEOiR7wm7dwAtoVaf0dh/HQPDu3+K4k79ya/TJd7SMvW1\n"+
    "7sxp2bkCgYEA9bCWSkn8Ju6lwHA0ohedVVMmdv9miC9oWgEb6d/T112jeIRaVZFj\n"+
    "JogIRsXN44dCfQsT2yrnL2nqhz3WeOzHzGEU6PUKUvqUyDAD/7BIFCl5k7XUsVlD\n"+
    "SwIDQRe0xrybaQN+OXXCRANgWkaluC6Gj0h2xKACsjaflx9N+1QqqucCgYEA4DwL\n"+
    "wvrr1U478KrUKtHjrcmNdCxJEm5Q89DrQ7xJ7z0I/rQ4Qy+yI0XLiedQvo/ibirF\n"+
    "/wBoSMtG58bNPQuifGgfzOo2YOLVnGpfUc94l+mgkQ8VgOqjJhOqCACo68Jv+yDx\n"+
    "HEq0kVSE3a2QJMASStZwIKFWVae2KYi1nGrb9gUCgYEAopehbjp2J6Gpiaf3/QlZ\n"+
    "srzbaMbuqNOO4Hl5apYY0J8Ebt5QFe6oSjieGZAQCDJcOvpYwqMq6cLTVXsD83Tn\n"+
    "aIca2mxHz9BLJAw6qTyVBtrHvYwI3PEwynPjiXFRzm/E/YM1Rnt6+52sZzH3u+L2\n"+
    "Y95V0xv9jMj/ZnhuGBSERCMCgYBksPIDI1QFW/U0lDFj7Q5VOr2nXj+N5DW71qPe\n"+
    "rc1xfbHtVhYxrVhL2IqWqWWrvMbL+68fXBp4HbgAWlhNQk07mjI1fTLf/Nw5OdcF\n"+
    "0KlxZfqxSNm6IyMR9SCUKV+xRoWselVrA+zjmdV0Cf1BU3KjYnnFXU18dywoqHgM\n"+
    "/js51QKBgQDjF3X6ZbjItJZhT0zkCHlLr9l6rquuKw8Ha7Aa17RrWmddCWMkSaLL\n"+
    "1vJrv5HRTDa9DmC9tsVXfkCmeX6Q0RUmo1lx0AtIAd+5/cXNlGSeTYZKTA/a5fc6\n"+
    "/exJyfcCRAWmCIM41YcEDuKuYmGcXLiuqWKP72CQi+3KbD+0ZzyikA==\n"+
    "-----END RSA PRIVATE KEY-----";
  // let sig = new jsrsasign.KJUR.crypto.Signature({"alg": "SHA1withRSA", "prov": "cryptojs/jsrsa","prvkeypem": signPrivateKey});
  // var hashAlg = 'sha1'; // 设置sha1
  // var sign = sig.signString(signData, hashAlg); // 加签
  // sign = jsrsasign.hex2b64(sign);
  // return sign;
  var key = jsrsasign.KEYUTIL.getKey(signPrivateKey);
// 指定签名算法 sha1对原文哈希
  let signature = new jsrsasign.KJUR.crypto.Signature({ alg: "SHA1withRSA" });
// 传入秘钥实例, 初始化
  signature.init(key);
// 传入待签明文
  signature.updateString(signData);
// 签名, 得到16进制字符结果
  let signResult = signature.sign();
// 签名hex转base64
  let signBase64 = jsrsasign.hextob64(signResult);
// console.log(signBase64);
  return signBase64;
}
